import React from 'react';
import {Field, Fields, reduxForm} from 'redux-form';
import ShowContactPerson from "../contact-person/ShowContactPerson";
import ServiceCategories from './ServiceCategories';
import ServiceDate from './ServiceDate';
import SubmitButton from "../common/SubmitButton";
import Price from "../common/Price";
import {servicesValidator} from "./ServicesValidator";
import ValidatedInputField from '../common/form/ValidatedInputField'
import ServiceType from "./ServiceType";
import BlockFormWrapper from "../common/form/BlockFormWrapper";
import FileUpload from "../files/FileUpload";
import VideoUploadRedux from "../VideoUploadRedux";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import MultistepSelectFormAdapter from '../common/MultistepSelectFormAdapter';
import DropDownOptions from '../helpers/DropDownOptions';
import ReactSelect from '../common/ReactSelect';
import RteEditor from "../common/form/RteEditor";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

let ServiceForm = props => {
    const {initialValues, categories, handleSubmit, handleReset, handleModalClick, contactPersons, isUpdate, intl} = props;

    let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;
    let fileSizeLimit = (MAX_FILE_SIZE > 1) ? MAX_FILE_SIZE - 1 : 1;

    return (
        <form onSubmit={handleSubmit} noValidate={true}>
            <BlockFormWrapper title={intl.formatMessage(messages.data)}>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.contactPerson)}</b>
                    </label>
                    <div className="col-sm-10">
                        <Field
                            type="select"
                            name="contactPersonId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(contactPersons, 'id', 'name')}
                            placeholder={intl.formatMessage(messages.contactPersonSelect)}
                        />
                        <Field
                            type="button"
                            name="showModal"
                            onChage={handleModalClick}
                            component={ShowContactPerson}
                            props={{
                                handleModalClick: handleModalClick,
                                text: intl.formatMessage(messages.serviceContactPersonDescription),
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.statistic)}</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                type="checkbox"
                                name="isStatisticAllowed"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description">
                                {intl.formatMessage(messages.sendStatisticToContactPerson)}
                            </span>
                        </label>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.comments)}</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                type="checkbox"
                                name="isCommentsAllowed"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description">
                                {intl.formatMessage(messages.serviceAllowVisitorsToComment)}
                            </span>
                        </label>
                    </div>
                </div>
                <Fields
                    type="datePicker"
                    names={['startDate', 'endDate']}
                    component={ServiceDate}
                    isUpdate={isUpdate}
                />
                <Field
                    name="categoryIds"
                    component={MultistepSelectFormAdapter}
                    data={categories}
                />
                <Price/>
                <Field
                    name="type"
                    isUpdate={isUpdate}
                    component={ServiceType}
                    options={
                        [
                            {title: intl.formatMessage(messages.wanted), value: 'wanted'},
                            {title: intl.formatMessage(messages.offering), value: 'offering'}
                        ]
                    }
                />
            </BlockFormWrapper>

            <BlockFormWrapper title={intl.formatMessage(messages.files)}>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.images)}</b>
                        {' ' + intl.formatMessage(messages.optional)}
                        <small className="form-text text-muted">
                            {`${intl.formatMessage(messages.filesMaxSize)} ${imageSizeLimit} MB.`}
                        </small>
                    </label>
                    <div className="col-sm-10">
                        <Fields
                            type="file"
                            names={[
                                'images',
                                'defaultImages',
                                'defaultImageIds',
                            ]}
                            component={FileUpload}
                            props={{
                                postUrl: 'api/privateV1/machines/validate-images',
                                type: 'image',
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b> {intl.formatMessage(messages.catalogs)}</b>
                        {' ' + intl.formatMessage(messages.optional)})
                        <small className="form-text text-muted">
                            {`${intl.formatMessage(messages.filesMaxSize)} ${fileSizeLimit} MB.`}
                        </small>
                    </label>
                    <div className="col-sm-10">
                        <Fields
                            type="file"
                            names={[
                                'files',
                                'defaultFiles',
                                'defaultFileIds',
                            ]}
                            component={FileUpload}
                            props={{
                                postUrl: 'api/privateV1/machines/validate-files',
                                type: 'file',
                            }}
                        />
                    </div>
                </div>
                <Fields
                    type="text"
                    names={[
                        'youtubeId',
                        'vimeoId',
                        'vimeoName',
                        'vimeoDescription',
                    ]}
                    component={VideoUploadRedux}
                />
            </BlockFormWrapper>

            <BlockFormWrapper title={intl.formatMessage(messages.files)}>
                <Field
                    type="text"
                    name="heading"
                    component={ValidatedInputField}
                    label={intl.formatMessage(messages.heading)}
                    className="form-control"
                />
                <Field
                    type="text"
                    name="description"
                    component={RteEditor}
                    placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
                    isUpdate={isUpdate}
                />
            </BlockFormWrapper>
            <hr/>
            <div className="form-group row">
                <div className="col-sm-12">
                    <div className="offset-sm-2">
                        <SubmitButton isUpdate={isUpdate}/>
                        <ResetButton onClick={handleReset}/>
                    </div>
                </div>
            </div>
        </form>
    )
};

ServiceForm = reduxForm({
    form: 'service',
    validate: servicesValidator,
    onSubmitFail: afterSubmitFail
})(ServiceForm);

export default injectIntl(ServiceForm);


// WEBPACK FOOTER //
// ./web/src/components/services/ServiceForm.jsx